"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ResourceDeleteErrorModal_1 = __importDefault(require("../common/ResourceDeleteErrorModal"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var PlayerDeleteErrorModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation").t;
    var _a = (0, react_1.useState)(false), detachingError = _a[0], setDetachingError = _a[1];
    var _b = (0, react_1.useState)(props.data || []), playerResourcesData = _b[0], setPlayerResourcesData = _b[1];
    var detachEventFromPlayer = function (playerId, eventId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deletePlayerEvent(playerId, eventId)];
                case 1:
                    _b.sent();
                    setPlayerResourcesData(playerResourcesData.filter(function (resourceData) { return resourceData.secondary_resource_id !== eventId; }));
                    setDetachingError(false);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setDetachingError(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var detachPresentationFromPlayer = function (playerId, presentationVersionId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deletePlayerPresentation(presentationVersionId, playerId)];
                case 1:
                    _b.sent();
                    setPlayerResourcesData(playerResourcesData.filter(function (resourceData) { return resourceData.secondary_resource_id !== presentationVersionId; }));
                    setDetachingError(false);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    setDetachingError(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var detachResourceFromPlayer = function (playerId, resourceId, isEvent) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isEvent) return [3 /*break*/, 2];
                    return [4 /*yield*/, detachEventFromPlayer(playerId, Number(resourceId))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, detachPresentationFromPlayer(playerId, String(resourceId))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (props.data) {
            setPlayerResourcesData(props.data);
        }
    }, [props.data]);
    var hasPresentations = playerResourcesData.some(function (resource) { return resource.resource_type === "PRESENTATION"; });
    var hasEvents = playerResourcesData.some(function (resource) { return resource.resource_type === "EVENT"; });
    var resourceAttachedToText = "";
    if (hasPresentations && hasEvents) {
        resourceAttachedToText = t("The player has attached presentations and events");
    }
    else if (hasPresentations) {
        resourceAttachedToText = t("The player has attached presentations");
    }
    else if (hasEvents) {
        resourceAttachedToText = t("The player has attached events");
    }
    return (react_1.default.createElement(ResourceDeleteErrorModal_1.default, { dataCy: "deletePlayerErrorModal", headerText: t("Unsuccessful deletion of player"), isShown: props.isShown, onClose: props.onClose, deleteResourceMethod: props.deleteResourceMethod, resourceId: props.resourceId, message: props.message, data: playerResourcesData, detachResourceMethod: detachResourceFromPlayer, resourceDetachError: detachingError, subTitleText: t("Deleting player was unsuccessful"), resourceAttachedToText: resourceAttachedToText, tooltipText: function (resourceType) { return t("Detach ".concat(resourceType.toLowerCase(), " from this player")); }, detachErrorTest: t("Error detaching resource") }));
};
exports.default = PlayerDeleteErrorModal;
